export function getErrorMessage(error: unknown): string {
  // 1. If it's a standard JS Error
  if (error instanceof Error) {
    return error.message;
  }

  // 2. If it's a raw string thrown (e.g., throw "Something went wrong")
  if (typeof error === "string") {
    return error;
  }

  // 3. If it's a custom object with a message property (common in Axios/API responses)
  if (error && typeof error === "object" && "message" in error) {
    return String((error as Record<string, unknown>).message);
  }

  // 4. Fallback if it's completely unrecognized
  return "An unexpected error occurred.";
}
